const Ext = require('ext')
const SizeMatcher = require('smartrules/designer/matchers/SizeMatcher')

const GteMatcher = Ext.define(null, {
  extend: SizeMatcher,

  constructor(cfg) {
    const config = Ext.apply(cfg, { direction: 'greater than' })
    this.callParent([config])
  }
})

module.exports = GteMatcher
